export default {
  system: {
    security: {
      name: '密级名称',
      contentSecretNames: '内容密级权限',
      annexSecretNames: '附件密级权限',
      namePlaceholder: '请输入密级名称',
      handleDesc: '操作说明： 这里是人员密级管理',
      handleDesc2: '操作说明： 这里是内容密级详情',
      handleDesc3: '操作说明： 这里是附件密级详情'
    }
  }
}
